import { ControlContainer, FormGroupDirective } from '@angular/forms';

export const API_KEY_HEADER = 'x-api-key' as const;
export const REFRESH_TOKEN_HEADER = 'refresh-token' as const;
export const DEFAULT_LOCALE_ID = 'es-DO' as const;
export const UNHANDLER_ERROR_MESSAGE = `
  Ha ocurrido un error inesperado. 
  Por favor contacte con el administrador del sistema
` as const;
export const FORM_VIEW_PROVIDER = { provide: ControlContainer, useExisting: FormGroupDirective } as const;
